// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Signup from "./features/signup/SignUp";
import SignIn from "./features/login/SignIn";
import ForgetPassword from "./features/forgetPassword/ForgetPassword";
import ForgetPasswordOne from "./features/forgetPassword/ForgetPasswordOne";
import Dashboard from "./features/dashboard/Dashboard";
import Recruitment from "./features/recruitment/Recruitment";
import OrganizationDetails from "./features/organizationDetail/OrganizationDetails";
import RolesPage from "./features/roles/RolesPage";
import Policies from "./features/policies/Policies";

function App() {
  return (
    <Router>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#f5f5f5",
        }}
      >
        <Routes>
          <Route path='/' element={<Navigate to='/signup' />} />
          <Route path='/signup' element={<Signup />} />
          <Route path='/signin' element={<SignIn />} />
          <Route path='/forget-password' element={<ForgetPassword />} />
          <Route path='/forget-password-one' element={<ForgetPasswordOne />} />
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/recruitment' element={<Recruitment />} />
          <Route path='/orgDetails' element={<OrganizationDetails />} />
          <Route path='/roles' element={<RolesPage />} />
          <Route path='/policies' element={<Policies />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
